import {Component, OnInit, ViewChild} from '@angular/core';
import {BannerComponent} from "./settingsections/banner/banner.component";
import {IntegrationComponent} from "./settingsections/integration/integration.component";
import {AutomatchComponent} from "./settingsections/automatch/automatch.component";
import {EventMessagesComponent} from "./settingsections/event-messages/event-messages.component";
import { UnassignedRequestEmailsComponent } from './settingsections/unassigned-request-emails/unassigned-request-emails.component';
import { Settings } from 'src/app/services/settings';

@Component({
	selector: 'app-generalsettings',
	templateUrl: './generalsettings.component.html',
	styleUrls: ['./generalsettings.component.css']
})
export class GeneralsettingsComponent implements OnInit{
	formTitle = 'General Settings';

	@ViewChild('banner', { static: true}) banner: BannerComponent;
	@ViewChild('integration', { static: true}) integration: IntegrationComponent;
	@ViewChild('automatch', { static: true}) automatch: AutomatchComponent;
	@ViewChild('eventmessages', { static: true}) eventmessages: EventMessagesComponent;
	@ViewChild('unassignedemails', { static: true}) unassignedemails: UnassignedRequestEmailsComponent;

	public visibleBanner = false;
	public visibleIntegration = false;
	public visibleAutomatch = false;
	public visibleSurveyMessages = false;
	public visibleUnassignedEmails = false;
	public visibleAutoClose = false;

	constructor() {

	}
	ngOnInit() {
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_BANNER', "READ")) {
			this.visibleBanner = true;
		}
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_APP_INTEGRATION', "READ")) {
			this.visibleIntegration = true;
		}
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_AUTOMATCH', "READ")) {
			this.visibleAutomatch = true;
		}
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_SURVEY_EMAILS', "READ")) {
			this.visibleSurveyMessages = true;
		}
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_AUTO_CLOSE', "READ")) {
			this.visibleAutoClose = true;
		}
		if (Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_UNASSIGNED_REQUEST_EMAILS', "READ")) {
			this.visibleUnassignedEmails = true;
		}
	}

}
